module.exports = __webpack_public_path__ + "img/logo.28e33d4f.svg";